<template>
	<form class="form-inline d-flex justify-content-between">
		<b-button size="sm" variant="secondary" @click="diceRoll('1d4')">d4</b-button>
		<b-button size="sm" variant="secondary" @click="diceRoll('1d6')">d6</b-button>
		<b-button size="sm" variant="secondary" @click="diceRoll('1d8')">d8</b-button>
		<b-button size="sm" variant="secondary" @click="diceRoll('1d10')">d10</b-button>
		<b-button size="sm" variant="secondary" @click="diceRoll('1d12')">d12</b-button>
		<b-button size="sm" variant="secondary" @click="diceRoll('1d20')">d20</b-button>
		<b-button size="sm" variant="secondary" @click="diceRoll('1d100')">d100</b-button>
		<div class="input-group input-group-sm flex-grow-1">
			<input type="text" class="form-control" placeholder="Custom" v-model="input">
			<div class="input-group-append">
				<b-button variant="secondary" @click="diceRoll(input)">Roll</b-button>
			</div>
		</div>

		<b-modal id="dice-roller" size="sm" title="Dice Roller" body-class="text-center" v-model="visible">
			<ul class="list-unstyled mb-0">
				<li class="h1" id="dieresult" :class="{
					'rolling': 	reroll
				}">{{total}}</li>
				<li v-if="label">{{label}}</li>
				<li><hr></li>
				<li><em><span id="diespec">{{roll.notation}}</span></em></li>
				<li v-for="(set, setIndex) in roll.rolls" :key="setIndex">
					<span class="mr-2" v-if="roll.rolls.length>1">{{parsed[setIndex]}}</span>
					<b-badge :class="{
						'badge-secondary': true, 
						'badge-danger': die.value == 1, 
						'badge-success': die.value == parsed[setIndex].max,
						'rolling': die.modifiers.includes('rolling')
					}" class="mr-1 d-inline-block" v-for="(die, dieIndex) in set.rolls" :key="dieIndex" @click="rerollSingle(setIndex, dieIndex)">{{die.value}}</b-badge>
				</li>
			</ul>
			<template v-slot:modal-footer>
				<b-button block variant="primary" @click="rerollAll()">Reroll All</b-button>
			</template>
		</b-modal>
	</form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
	data: function() {
		return {
			input: '',
		}
	},
	computed: {
		visible: {
			get: function() {
				return this.$store.state.modals.dice.visible
			},
			set: function(value) {
				if(value){
					this.$store.commit('modals/dice/show')
				}else{
					this.$store.commit('modals/dice/hide')
				}
			}
		},
		...mapState('modals/dice',[
			'roll',
			'reroll',
			'label',
		]),
		...mapGetters('modals/dice',[
			'total',
			'dice',
			'parsed',
		]),

	},
	methods: {
		diceRoll: function(dieSpec) {
			this.$store.dispatch('modals/dice/roll',dieSpec)
		},
		rerollSingle: function(setIndex, dieIndex){
			this.$store.dispatch('modals/dice/rerollOne',{
				setIndex,
				dieIndex,
			})
		},
		rerollAll: function(){
			this.$store.dispatch('modals/dice/rerollAll')
		}
	}
}
</script>

<style>
.modal-backdrop {
	opacity: .5;
}
.rolling {
	animation: fade .75s linear forwards;
}

@keyframes fade {
	0% { opacity: 0; }
	100% { opacity: 1; }
}
</style>